module.exports = __webpack_public_path__ + "static/media/18ECA10.4b1eb54c.jpg";